import anime from "animejs";

const onElementAppear = (el, index) => {
    anime({
        targets: el,
        opacity: [0, 1],
        delay: index * 20,
        duration: 150,
        easing: "easeOutSine"
    });
};

exports.onElementAppear = onElementAppear;

const onElementExit = (el, index, removeElement) => {
    anime({
        targets: el,
        opacity: 0,
        duration: 150,
        complete: removeElement,
        delay: index * 20,
        easing: "easeOutSine"
    }).pause;
};

exports.onElementExit = onElementExit;
